import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type {
  RequestAffiliateWithdrawalRequest,
  RequestAffiliateWithdrawalResponse,
} from './request-affiliate-withdrawal.types'

const requestAffiliateWithdrawal = async (
  data: RequestAffiliateWithdrawalRequest,
): Promise<RequestAffiliateWithdrawalResponse> => {
  const response = await apiClient.post<RequestAffiliateWithdrawalResponse>(
    '/v1/affiliation/withdrawals',
    data,
  )
  return response.data
}

interface UseRequestAffiliateWithdrawalOptions {
  feedback?: MutationFeedback
}

export const useRequestAffiliateWithdrawal = (
  options?: UseRequestAffiliateWithdrawalOptions,
) => {
  return useMutation({
    mutationFn: requestAffiliateWithdrawal,
    meta: {
      // The requested amount leaves the available balance immediately.
      invalidatesQuery: ['affiliate-withdrawals', 'affiliate-dashboard'],
      ...options?.feedback,
    },
  })
}
